<template>
    <form @submit.prevent="save">
        <div class="row">
            <custom-input
                v-model="firstName"
                :title="$t('ACCOUNT_CARDS__FIRST_NAME')"
                @clear="firstName = ''"
            />
            <custom-input
                v-model="lastName"
                :title="$t('ACCOUNT_CARDS__LAST_NAME')"
                @clear="lastName = ''"
            />
            <custom-select
                v-model="country"
                :title="$t('ACCOUNT_CARDS__COUNTRY')"
                :options="countriesOptions"
                @clear="country = ''"
            />
            <date-picker
                :title="$t('ACCOUNT_CARDS__BIRTH_DATE')"
                v-model="birthDate"
                @clear="birthDate = ''"
            />
        </div>
        <div class="row">
            <custom-input
                v-model="address"
                :title="$t('ACCOUNT_CARDS__ADDRESS')"
                @clear="address = ''"
            />
            <custom-input v-model="city" :title="$t('ACCOUNT_CARDS__CITY')" @clear="city = ''" />
            <custom-input v-model="email" :title="$t('ACCOUNT_CARDS__EMAIL')" @clear="email = ''" />
            <custom-input
                v-model="mobile"
                :title="$t('ACCOUNT_CARDS__MOBILE')"
                @clear="mobile = ''"
            />
        </div>
        <div class="row" v-if="isSupervisor">
            <custom-input
                v-model="rolloverAmount"
                :title="$t('ACCOUNT_CARDS__ROLLOVER_AMOUNT')"
                inputType="number"
                @clear="rolloverAmount = ''"
            />
            <custom-input
                v-model="maxLossPerMonth"
                :title="$t('ACCOUNT_CARDS__MAX_LOSS_PER_MONTH')"
                inputType="number"
                @clear="maxLossPerMonth = ''"
            />
            <custom-input
                v-model="maxLossPerMonthByBetting"
                :title="$t('ACCOUNT_CARDS__MAX_LOSS_BETTING')"
                inputType="number"
                @clear="maxLossPerMonthByBetting = ''"
                helperText="* Max Loss Per Month By Betting"
            />
            <custom-input
                v-model="maxLossPerMonthByGambling"
                title="Max Loss Gambling"
                inputType="number"
                @clear="maxLossPerMonthByGambling = ''"
                helperText="* Max Loss Per Month By Gambling"
            />
        </div>
        <div class="row">
            <button class="btn">{{ $t('ACCOUNT_CARDS__SAVE') }}</button>
        </div>
    </form>
</template>

<script>
import CustomInput from '@/components/ReusableComponents/CustomInput/CustomInput.vue'
import CustomSelect from '@/components/ReusableComponents/CustomSelect/CustomSelect.vue'
import DatePicker from '@/components/ReusableComponents/DatePicker/DatePicker.vue'
import axios from '@/Helpers/AxiosInstance.js'
import { getDateString } from '@/Helpers/HelperFunctions.js'
export default {
    components: {
        CustomInput,
        CustomSelect,
        DatePicker,
    },
    props: {
        cardInfo: Object,
    },
    created() {
        this.setInputs()
    },
    data() {
        return {
            firstName: '',
            lastName: '',
            rolloverAmount: '',
            maxLossPerMonth: '',
            maxLossPerMonthByBetting: '',
            maxLossPerMonthByGambling: '',
            email: '',
            mobile: '',
            address: '',
            city: '',
            country: '',
            birthDate: '',
        }
    },
    methods: {
        save() {
            axios
                .post('WebShop/EditAccountCard', {
                    cardId: this.cardInfo.id,
                    firstName: this.firstName,
                    lastName: this.lastName,
                    rolloverAmount: this.rolloverAmount,
                    maxLossPerMonth: this.maxLossPerMonth,
                    maxLossPerMonthByBetting: this.maxLossPerMonthByBetting,
                    maxLossPerMonthByGambling: this.maxLossPerMonthByGambling,
                    email: this.email,
                    mobile: this.mobile,
                    address: this.address,
                    city: this.city,
                    countryId: this.country,
                    birthDate: this.birthDate,
                })
                .then(resp => {
                    if (resp.data.status == 1) {
                        this.$emit('showMessage', {
                            purpose: 'success',
                            text: 'Saved Successfully!',
                        })
                    } else {
                        this.showError(resp.data.status)
                    }
                })
                .catch(() => this.showError())
        },
        setInputs() {
            this.firstName = this.cardInfo.firstName
                ? this.cardInfo.firstName
                : ''
            this.lastName = this.cardInfo.lastName ? this.cardInfo.lastName : ''
            this.email = this.cardInfo.email ? this.cardInfo.email : ''
            this.mobile = this.cardInfo.mobile ? this.cardInfo.mobile : ''
            this.city = this.cardInfo.city ? this.cardInfo.city : ''
            this.address = this.cardInfo.address ? this.cardInfo.address : ''
            this.country = this.cardInfo.countryId
                ? this.cardInfo.countryId + ''
                : ''
            this.birthDate = this.cardInfo.birthDate
                ? getDateString(this.cardInfo.birthDate, 'yyyy-MM-dd')
                : ''
            this.rolloverAmount = this.cardInfo.rolloverAmountDecimal
                ? this.cardInfo.rolloverAmountDecimal
                : ''
            this.maxLossPerMonth = this.cardInfo.maxLossPerMonthDecimal
                ? this.cardInfo.maxLossPerMonthDecimal
                : ''
            this.maxLossPerMonthByBetting = this.cardInfo
                .maxLossPerMonthByBettingDecimal
                ? this.cardInfo.maxLossPerMonthByBettingDecimal
                : ''
            this.maxLossPerMonthByGambling = this.cardInfo
                .maxLossPerMonthByGamblingDecimal
                ? this.cardInfo.maxLossPerMonthByGamblingDecimal
                : ''
        },
        showError(status) {
            var text = 'An Error Occurred While Saving!'
            var code = this.statusCodes.filter(e => e.key == status)[0]
            if (code) text = this.$t('STATUS-CODE__' + code.value)
            this.$emit('showMessage', {
                purpose: 'error',
                text: text,
            })
        },
    },
    watch: {
        cardInfo() {
            this.setInputs()
        },
    },
    computed: {
        isSupervisor() {
            return this.$store.state.shop
        },
        countriesOptions() {
            var countries = this.$store.state.countries
            if (countries.length == 0) return []
            var options = []
            countries.forEach(c => {
                options.push({
                    title: c.countryName,
                    value: c.countryId,
                })
            })
            return options
        },
        statusCodes() {
            return this.$store.state.statusCodes
        },
    },
}
</script>

<style scoped lang="scss">
form {
    margin-top: 100 * $rem;

    .row {
        display: flex;
        margin-bottom: 20 * $rem;

        label,
        .selected-box,
        .select-wrapper,
        /deep/ ul.options {
            margin-right: 15 * $rem;
            width: 220 * $rem;

            &:last-child {
                margin-right: 0;
            }
        }
    }

    .btn {
        margin-top: 20 * $rem;
        width: 150 * $rem;
        height: 40 * $rem;
        font-size: 16 * $rem;
    }
}

@media only screen and (max-width: 1100px) {
    form .row {
        flex-wrap: wrap;
        margin-top: -25 * $rem;

        label,
        .selected-box,
        .select-wrapper,
        /deep/ ul.options {
            width: calc(50% - #{15 * $rem});
            margin-top: 25 * $rem;
        }

        .btn {
            margin-top: 40 * $rem;
        }
    }
}

@media only screen and (max-width: 530px) {
    form .row {
        label,
        .selected-box,
        .select-wrapper,
        /deep/ ul.options {
            width: calc(100% - #{15 * $rem});
        }
    }
}
</style>
